export default {
  lang: 'French',
  homeScreen: {
    title: 'Concrétisez Vos Rêves',
    stayConnected: 'Rester Connecté(e):',
    download: 'Télécharger maintenant',
  },
  notification: {
    newAndNow: 'Nouveautés !',
    alert: 'Alerte',
    message: 'Message',
    contest: 'Concours',
    badge: 'Nouveau Badge',
    'content-update': 'Mise à Jour du Contenu',
    events: 'Événements',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Voyons si nous pouvons trouver un profil existant pour vous dans notre système.',
      homeTitleSub:
        "Saisissez l'adresse électronique que vous utilisez habituellement pour vous connecter aux programmes de formation.",
      noAccount:
        "Aucun compte n'a été trouvé ({email}), veuillez essayer avec un autre email ou créer un compte maintenant.",
      continueButton: 'Continuer',
      success:
        "La mise à jour de votre compte a été effectuée avec succès ! Vous serez bientôt redirigé vers la page d'accueil.",
      successNewAccount:
        'Pour compléter votre inscription, vous recevrez un courriel de confirmation pour vérifier votre compte.',
      loginButton: 'Connexion',
      matchFound:
        'Nous avons trouvé une correspondance, veuillez saisir votre mot de passe pour continuer.',
      magicLink:
        "Connectez-vous à l'aide d'un lien figurant dans votre courrier électronique :",
      magicLinkButton: 'Demande de lien magique',
      magicLinkTitle:
        'Un lien direct vous est envoyé par e-mail pour vous permettre de vous inscrire instantanément.',
      otherEmailButton: 'Soumettre',
      title:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      titleIndustry:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      register: 'Créer un compte',
      agent: 'Conseiller en voyages',
      visitor: "Visiteur de l'industrie",
      step1: "Étape 1 : Type d'utilisateur",
      step2: 'Étape 2 : Créer un compte',
      step3: 'Étape 3 : Créer votre profil',
      marketingOptIn:
        "Êtes-vous sûr de ne pas vouloir rester en contact avec l'équipe commerciale de ce programme ?",
      optIn: 'Oui, je suis intéressé',
      optOut: 'Pas intéressé',
      step2Sub1: 'Parlez-nous de vous',
      step2Sub2: 'Parlez-nous de votre entreprise',
      privacyHead: 'LES PRÉFÉRENCES EN MATIÈRE DE COMMUNICATION',
      privacySub:
        "Cochez les cases ci-dessous pour vous assurer de recevoir les communications importantes de l'équipe commerciale du fournisseur (mises à jour et annonces de produits, récompenses, incitations, FAM, etc.) et les initiatives de TravPRO Mobile en matière de réseautage et d'aide à la vente pour les professionnels du voyage.",
      privacy:
        "Nous protégeons votre vie privée et ne vendons pas, n'utilisons pas à mauvais escient et ne trahissons pas votre confiance.",
      store:
        "Téléchargez facilement ce programme dans votre magasin d'applications :",
      powered: 'ALIMENTÉ PAR',
      toastMessage: {
        forgotSuccess:
          'Nous vous avons envoyé par e-mail le lien de réinitialisation de votre mot de passe ! Vous serez redirigé vers la page de connexion dans 10 secondes.',
        emailNotExisting:
          "L'adresse électronique que vous avez saisie n'existe pas.",
        magicLinkMessage:
          'Veuillez patienter, nous sommes en train de vous inscrire.',
        magicLinkError:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkError1:
          "Nous n'avons pas trouvé de jeton valide, veuillez vous connecter ou demander un nouveau lien magique. Si le problème persiste, veuillez nous contacter à l'adresse suivante : info@travpromobile.com.",
        magicLinkError2:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkSuccess:
          "Consultez votre courrier électronique à l'adresse {email}. Il contient un lien magique qui vous permettra de vous connecter.",
        magicLinkErrorWait:
          'Veuillez attendre 5 minutes entre les demandes de liens magiques.',
        emailNotFoundError:
          "L'adresse électronique que vous avez saisie ne figure pas dans nos dossiers. Veuillez vérifier les fautes d'orthographe ou créer un compte.",
      },
      errors: {
        zipCodeNotFound: 'Code postal non trouvé, réessayez',
        zipCodeOnlyNumbers: 'ZipCode ne peut contenir que des chiffres',
        password: 'Veuillez saisir un mot de passe',
        passwordNotMatching: 'Les mots de passe saisis ne correspondent pas',
        passwordTooShort:
          'Le mot de passe doit comporter au moins 8 caractères',
        emailExists:
          "Cette adresse électronique existe déjà ou n'est pas valide. Veuillez essayer avec une autre adresse électronique ou vous connecter à votre compte.",
        fillInAllFields: 'Veuillez remplir tous les champs obligatoires',
        fillInEmail: 'Veuillez indiquer votre adresse électronique.',
        emailNotExisting:
          "L'adresse électronique que vous avez saisie n'existe pas.",
      },
      fields: {
        forgotSubCopy:
          'Vous avez oublié votre mot de passe et souhaitez le modifier ? ',
        forgotSubCopy2:
          'Vous voulez éviter le mot de passe ? Nous vous enverrons un e-mail contenant un lien magique qui vous permettra de vous connecter automatiquement au programme.',
        city: 'Ville',
        companyName: "Nom de l'entreprise",
        role: 'Votre rôle',
        description:
          "Laquelle décrit le mieux l'activité de votre entreprise ?",
        country: 'Pays',
        password: 'Mot de passe',
        passwordRegister: 'Choisissez un mot de passe (8 caractères minimum)',
        passwordConfirm: 'Confirmer le mot de passe',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        agency: "Nom de l'agence",
        title: 'Votre rôle (Sélectionnez un rôle)',
        company: "Nom de l'entreprise",
        select: 'Sélectionnez une option ci-dessous',
        state: 'État',
        province: 'Province/Région/État',
        zipCode: 'Code postal',
        postalCode: 'Code postal',
        affiliate:
          'Quel est le groupe auquel vous êtes PRINCIPALEMENT affilié ?',
        hostAgency: "Votre agence d'accueil ?",
        executive: 'Cadre',
        management: 'Gestion',
        marketing: 'Marketing',
        sales: 'Vente',
        coordinator: 'Coordinateur',
        opt: "Restez en contact avec l'équipe commerciale de ce programme et recevez des mises à jou",
        optMarketing:
          'Restez en contact avec TravPRO en ce qui concerne les programmes et événements similaires.',
        retail: "Façade d'un magasin de détail",
        home: 'Agent à domicile',
        independent: 'Entrepreneur indépendant',
        host: "Agence d'accueil",
        call: "Centre d'appel ou agence en ligne",
        other: 'Autres',
        describes:
          "Qu'est-ce qui décrit le mieux votre activité et celle de votre agence ?",
      },
    },
    title:
      'Programme de formation professionnelle en voyage et de promotion des ventes',
    welcome: {
      headerTop: 'Bienvenue au',
      headerBottom: 'Compagnon de ventes de Visit California STAR',
    },
    sellingPoints: [
      'Ressource de conversion des ventes au quotidien',
      'Découvertes et présentations à fort impact',
      "Personnaliser avec le dossier 'Favoris'",
      "En ligne, hors ligne - à tout moment, n'importe où",
    ],
    emailPrompt:
      'Veuillez entrer votre adresse email pour confirmer que vous êtes un professionnel du voyage.',
    tAndC: {
      agree: 'En continuant, vous acceptez notre',
      privacyPolicy: ' politique de confidentialité',
      and: ' et ',
      termsConditions: 'nos termes et conditions',
    },
    fields: {
      agency: 'Agence',
      email: 'Email',
      firstName: 'Prénom',
      lastName: 'Nom',
      agencyName: "Nom de l'agence",
      stateProvince: 'État / Province',
      registrationCode: 'Code Promo (Optionnelle)',
      required: 'Obligatoire',
      invalidEmail: 'Adresse email invalide',
      opt: 'Reste en contact! Oui, j’aimerais opter pour les communications de Visit California qui me tiendront au courant des actualités, des événements, des incitations, des visites familiales et plus encore!',
      forgot:
        'Vous avez oublié votre mot de passe ? Cliquez sur le bouton ci-dessous et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
    },
    forgot: 'Réinitialiser le mot de passe',
    noAgent: {
      noAgentButton: 'Je ne suis pas un conseiller',
      title: 'Merci de votre intérêt pour California ',
      messageWeb:
        'Le contenu de ce site est exclusivement reservé aux professionnels du voyage.',
      messageMobile:
        "Une partie du contenu de cette application est exclusivement reservé aux professionnels du voyage, mais n'hésitez pas à naviguer un aperçu de ce que cette application peut offrir en appuyant sur « Continuer ». ",
      continue: 'Continuez',
      visitWebsite: 'Visiter le site web >',
    },
    newUser: 'Nouvel utilisateur',
    register: 'Enregistrer',
  },
  welcomeScreen: {
    title:
      'Bienvenue au\nProgramme de formation et compagnon de ventes California STAR \n',
    helloUser: 'Salut',
    hello: 'Salut',
    fromAgency: 'de {agency}',
    notUser: 'Pas {name}?',
    introOnline:
      "Entraînez-vous immédiatement en ligne ou préchargez le contenu afin qu'il soit toujours disponible pour une utilisation hors ligne !",
    introOffline: 'Vous avez déjà la dernière version préchargée.',
    startTraining: 'Commencez par la formation',
    downloader: {
      preload: 'Précharger',
      stop: 'Arrêter',
      init: 'Initialiser...',
      lastUpdate: 'Dernière mise à jour:',
    },
  },
  trainingScreens: {
    review: 'Revisez',
    start: 'Commencer',
    continue: 'Continuer',
    welcome:
      '«Bienvenue dans notre section Formation repensée. Complétez simplement des modules pour gagner des points vers votre objectif ultime de devenir un Gold CA STAR! La barre à droite vous montrera exactement comment vous allez!',
    restart: 'Redémarrer',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Compléter',
    unlock:
      'Déverrouiller ce chapitre en complétant le chapitre de formation {number}.',
    unlockSpecialization: 'Débloquez ce chapitre en complétant Les Fondations',
    unlockSubtitle:
      'Déverrouiller plus de chapitres en complétant les chapitres de formation.',
    allUnlocked: 'Vous avez déverrouillé tous les chapitres !',
    certificate: 'Certificat',
    courseComplete: 'Cours achevé !',
    chapterComplete: 'Chapter complete!',
    message: '{count} Message de STAR',
    messagePlural: '{count} Messages de STAR',
    endReached: 'Vous avez atteint la fin',
    retainEnd:
      "Utilisez la barre supérieure pour naviguer ce chapitre ou appuyez sur le bouton retour pour revenir à la vue d'ensemble.",
    watchListenRead: 'Regarder, écouter et lire plus',
    trouble:
      'Il parait que vous avez des problèmes, voulez-vous sauter cette question ?',
    confirm: 'Confirmer votre réponse',
    choose: 'Veuillez choisir une réponse',
    chapter: 'Chapitre',
    essential: 'Modules essentiels',
    essentialSub:
      'Complétez ces modules pour obtenir votre statut CA STAR Bronze',
    specialization: 'Modules de spécialisation',
    specializationSub:
      'Complétez ces modules pour obtenir le statut Silver CA STAR',
    status: 'Situation actuelle',
  },
  nav: {
    home: 'Accueil',
    train: 'Former',
    retain: 'Conserver',
    directory: 'Agenda',
    promote: 'Promouvoir',
    sell: 'Vendre',
    info: 'Info',
    media: 'Média',
    favorites: 'Favoris',
    contact: 'Contact',
    reportCard: 'Bulletin',
    accountSettings: 'Paramètres du compte',
    messages: 'Message',
    search: 'Rechercher',
    showcases: 'Vitrines',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'Nos modules de formation',
    retain: 'Conserver',
    subapps: 'Mini modules de nos destinations partenaires',
    maintrainings: 'La Fondation',
    subtrainings: "L'expérience",
  },
  pageDescriptions: {
    train: 'Formez, engagez et devenez un expert.',
    retain:
      "Votre ressource incontournable pour conserver vos connaissances d'expert et permettre vos efforts de vente. Utilisez cette zone pour répondre de manière experte à une question sur un produit ou même comme présentation de vente impromptue - à tout moment, n'importe où et depuis n'importe quel appareil.",
    promote: '',
    sell: '',
    favorites: 'Vérifiez votre contenu préféré personnellement',
    search: 'Naviguez tout le contenu',
    subapps: 'En savoir plus sur nos partenaires',
    maintrainings:
      'Complétez ces chapitres essentiels pour obtenir votre diplôme!',
    subtrainings:
      'Gagnez un badge en complétant chaque expérience spécialisée ci-dessous.',
  },
  general: {
    showcase: 'Showcases',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    back: 'Retour',
    close: 'Fermer',
    page: 'Page',
    search: 'Rechercher',
    logIn: 'Se Connecter',
    logOut: 'Se déconnecter',
    viewItem: 'Visualiser',
    showcase: 'Showcases',
    imageNotFound: 'Image non trouvée',
    noResultsFor: "Aucun résultat n'a été trouvé pour :",
    noFavorites: "Vous n'avez pas encore de favoris.",
    noMessages: "Vous n'avez pas encore reçu de messages !",
    resultsFor: 'Des résultats pour :',
    showAll: 'Afficher tout',
    connectionError: 'Erreur de connexion',
    alreadyExists: 'Existe déjà',
    pageNotFound: '404 Page non trouvée !',
    oops: 'Euh oh...',
    overview: "Retour à l'aperçu",
    complete: 'Cours achevé !',
    share: 'Partager',
    destinations: 'Mini formation de partenaire de la Californie',
    essentials: 'Les essentiels de la Californie',
    trainingLibrary: 'Bibliothèque de formation',
    message: '{count} Message de STAR',
    messagePlural: '{count} Messages de STAR',
    badge: 'Badge',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Mise en page',
    web: 'Site Web',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Faire tourner les cadrans pour faire correspondre à la réponse',
    fitb: 'Remplir les espaces vides',
    flip: 'Changer le numéro pour correspondre à la réponse',
    multipleChoice: 'Choisir la (les) bonne (s) réponse (s)',
    slider: "Choisir la bonne réponse à l'aide du curseur",
    map: 'Répondre à la question en appuyant sur le bon emplacement sur la carte',
    dropdown: 'Choisir...',
    true: 'Vrai',
    false: 'Faux',
  },
  cookies: {
    consent: 'ACCEPTER',
    optout: 'Se désengager',
    settings: 'Paramètres de confidentialité ',
    message:
      'Vous ne nous avez rien communiqué à propos de vos préférences en matière de confidentialité des données !',
    disabled: "Il semble que vous ayez désactivé l'utilisation des cookies.",
    use: "Le {Nom de l’app} exige l'utilisation de cookies pour vous offrir la meilleure expérience.",
    details: 'À quoi servent les cookies ?',
    enable: 'Voir comment activer vos cookies {ici}.',
    here: 'ici',
  },
  notLoggedIn: {
    super: "Vous n'êtes pas connecté",
    title: 'Vous devez être connecté pour visualiser ce contenu',
    guest: 'L’invité',
  },
  demo: {
    message: 'Ce site Web est une démonstration du produit final.',
    consent: '',
  },
  share: {
    header: '',
    download: 'download',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header:
      "Il semble que vous essayez d'accéder à {appName} à partir d'un appareil mobile.",
    body: "Pour télécharger ce programme, visitez tout simplement l’app store et recherchez {appName} ou cliquez sur l'un des boutons ci-dessous",
    benefits: {
      header: 'Cela vous fournira :',
      1: 'La portabilité',
      2: 'Pas besoin de WiFi, entraînez-vous quand et où il vous convient',
      3: 'Des outils et des ressources de vente à votre portée',
    },
  },
  sharing: {
    twitter:
      'Envisagez de passer vos prochaines vacances en Californie…\nJuste pour vous de California STAR...\n',
    imageEmailSubject: 'Juste pour vous de California STAR...',
    imageEmailCopy:
      'Prenez une minute pour examiner le contenu de vacances de California STAR… Amusez-vous !',
    videoEmailSubject:
      'Des idées cool de vacances de California STAR partagées avec vous !',
    videoEmailCopy:
      'Je pensais que vous apprécieriez cette vidéo de vacances de California STAR. Cliquez simplement sur le lien ci-dessous pour regarder. Amusez-vous !',
    infographicEmailSubject:
      'Partager quelque chose à propos des idées de vacances de California STAR...',
    infographicEmailCopy:
      'Je pensais que cela vous intéresserai, prenez une minute pour visualiser le contenu ci-joint. À bientôt !',
    copyURL: 'Copier le lien',
    copied: 'Copié',
  },
  newTrainingFlow: {
    tip: 'Vous obtenez votre statut en complétant les modules de chaque niveau.  Rêvez en grand et obtenez le statut Gold CA STAR by completing aen complétant tous les modules !',
    essentialModules: 'Modules essentiels',
    finishBronze:
      'Complétez ces modules pour obtenir votre statut CA STAR Bronze',
    specializationModules: 'Modules de spécialisation',
    finishSilver: 'Complétez ces modules pour obtenir le statut Silver CA STAR',
    partnerModules: 'Modules partenaires',
    finishGold: 'Complétez ces modules pour obtenir votre statut Gold CA STAR',
    currentStatus: 'Situation actuelle',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: 'jusqu’à ce que vous ayez atteint le {rank} classement !',
    outOf: 'de {points}  XP sur les',
    pointsToRank: '{pointsToLevel} XP devrait se classer :  ({rank})',
  },
  points: {
    completed: '{completed} / {total} Compléter',
  },
  new: {
    achievements: 'Réalisations',
  },
  badgeView: {
    title: 'Réalisations en matière de formation',
    subtitle:
      'Bienvenue sur le tableau de bord de vos réalisations, où vous pouvez consulter, suivre et télécharger vos diplômes et vos badges de spécialisation.',
    badgeDisplayTitle: 'Statut de la réalisation métallique',
    badgeAchievement:
      "Vous avez atteint le statut {rank} ! Cliquez sur l'icône à droite pour afficher et partager votre statut.",
    bronze: 'Bronze',
    silver: 'Argent',
    gold: 'Or',
    platinum: 'Platine',
    complete: 'COMPLET',
    diploma: 'Diplôme',
    chapterBadges: 'Badges de spécialisation',
    partnerBadges: 'Badges des partenaires',
  },
  badgeDisplay: {
    status: "État d'avancement de la formation",
  },
  search: {
    pages: 'Pages',
    resources: 'Ressources',
  },
};
